import { render, staticRenderFns } from "./TablePatientDiagnosis.vue?vue&type=template&id=6ce4d0c2&"
import script from "./TablePatientDiagnosis.vue?vue&type=script&lang=js&"
export * from "./TablePatientDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./TablePatientDiagnosis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports